import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-web-share',
  template: `
    <p>
      web-share works!
    </p>
  `,
  styles: []
})
export class WebShareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
